<div>
  <div class="flex items-center justify-between mb-4">
    <h2 class="text-lg font-semibold">{{ 'usedControls.title' | translate }}</h2>
  </div>

  @if (error()) {
    <div class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4">
      {{ error() }}
    </div>
  }
  @if (isLoading()) {
    <div class="flex items-center justify-center p-8">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-main"></div>
    </div>
  } @else if (controls().length === 0) {
    <div class="text-center text-gray-500 p-8">
      {{ 'usedControls.noControls' | translate }}
    </div>
  } @else {
    <div class="space-y-6">
      @if (cmiControls().length > 0) {
        <div>
          <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
            {{ 'usedControls.sectionCmi' | translate }}
          </h3>
          <div class="space-y-4">
            @for (control of cmiControls(); track control.id) {
              <cmi-content-control-item
                [control]="control"
                [buttonTooltip]="'usedControls.select' | translate"
                (selectItem)="selectControl($event)" />
            }
          </div>
        </div>
      }
      @if (reportControls().length > 0) {
        <div>
          <h3 class="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-2">
            {{ 'usedControls.sectionReports' | translate }}
          </h3>
          <div class="space-y-4">
            @for (control of reportControls(); track control.id) {
              <cmi-content-control-item
                [control]="control"
                [buttonTooltip]="'usedControls.select' | translate"
                (selectItem)="selectControl($event)" />
            }
          </div>
        </div>
      }
    </div>
  }
</div>
